import { useQueryParams } from '~/hooks/use-query-params/useQueryParams';
import { queryKeys } from '~/routes/app-paths';

export const DOCUMENT_MODAL_KEY = 'document';

export const useDocumentModal = () => {
  const { params, setQueryParams } = useQueryParams();
  const isOpen = params[queryKeys.activeModal] === DOCUMENT_MODAL_KEY;
  const activeDocumentId = params[queryKeys.documentId];

  const openModal = (id: string) => {
    setQueryParams({
      [queryKeys.activeModal]: DOCUMENT_MODAL_KEY,
      [queryKeys.documentId]: id,
    });
  };

  const closeModal = () => {
    setQueryParams({
      [queryKeys.activeModal]: undefined,
      [queryKeys.documentId]: undefined,
    });
  };

  return { isOpen, activeDocumentId, openModal, closeModal };
};
